import React from "react";
import { useQuery } from '@tanstack/react-query';
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import { getScheduledEventUpdates } from "@/helpers/apis";
import { GetScheduledEventUpdatesResponse } from "@/pages/explorer/types";
import { EmptyScreen } from "@/pages/warehouse/misc";
import { ScrollContainer } from "@/components/scrollContainer";
import TimelineScheduledEventIconWithDate from "./TimelineScheduledEventIcon";
import { timeline_contentStyle, iconStyle } from "./timelineStyles";
import styles from "@/pages/query/styles.module.scss";
import { Spinner, Stack } from "@altimateai/lego";

const GET_SCHEDULED_EVENTS_UPDATES = "GET_SCHEDULED_EVENTS_UPDATES";

const getScheduledEventText = (data: GetScheduledEventUpdatesResponse): string => {
  const { event_type, created_by, created_at } = data;
  const formattedDate = new Date(created_at).toLocaleString();
  return `${created_by} ${event_type} the schedule on ${formattedDate}`;
};

interface ScheduledEventsActivityProps {
  schedule_id: string;
}

const ScheduledEventsActivity: React.FC<ScheduledEventsActivityProps> = ({ schedule_id }) => {
  const { data, isFetching } = useQuery({
    queryKey: [GET_SCHEDULED_EVENTS_UPDATES, schedule_id],
    queryFn: () => getScheduledEventUpdates({ schedule_id }),
  });

  if (isFetching)
    return (
      <Stack justify="center" align="center" className="al-h-40">
        <Spinner />
      </Stack>
    );

  if (!data || !data.length)
    return (
      <EmptyScreen
        title="No activity yet"
        subTitle="No activity found for the selected schedule."
      />
    );

  return (
    <div id="scheduledEventsActivity" className={styles.opportunityActivity}>
      <VerticalTimeline
        className={styles.vertical_timeline}
        layout={"1-column-left"}
        lineColor={"#E7E8EA"}
      >
        <ScrollContainer>
          <div className={styles.scroll_content}>
            {data.map(d => (
              <VerticalTimelineElement
                key={d.event_id}
                className={styles.vertical_timeline_element}
                contentStyle={timeline_contentStyle}
                contentArrowStyle={{
                  display: "none",
                }}
                iconStyle={iconStyle}
                icon={TimelineScheduledEventIconWithDate(d.created_by, d.event_type, d.created_at)}
              >
                {getScheduledEventText(d)}
              </VerticalTimelineElement>
            ))}
          </div>
        </ScrollContainer>
      </VerticalTimeline>
    </div>
  );
};

export default ScheduledEventsActivity;
